<template>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">Property Action</h5>
            <template v-if="status.statisticSummary">
                <apexchart
                    v-if="statisticSummary.length"
                    type="bar"
                    height="200"
                    :options="chartOptions"
                    :series="series"
                />
                <b-alert v-else show variant="warning" class="text-center">
                    <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                </b-alert>
            </template>
            <div v-else class="d-flex justify-content-center align-items-center" style="height: 200px;">
                <b-spinner variant="info" role="status"></b-spinner>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { propertyActionMethods } from "@/state/api";
import { PROPERTY_ACTION_MODULE } from "@/state/api/propertyAction.state";

export default {
    created() {
        this.getPropertyActionStatisticSummary();
    },
    methods: {
        ...propertyActionMethods,
    },
    computed: {
        ...mapState(PROPERTY_ACTION_MODULE, ['status']),
        statisticSummary() {
            return this.$store.state.api.propertyAction.statisticSummary || [];
        },
        series() {
            return [{
                name: 'Total',
                data: this.statisticSummary.map(item => Number(item.value) || 0),
            }];
        },
        chartOptions() {
            return {
                chart: {
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: { columnWidth: '45%', distributed: true },
                },
                xaxis: {
                    categories: this.statisticSummary.map(item => item.name),
                },
                yaxis: {
                    min: 0,
                    decimalsInFloat: 0,
                },
                legend: { show: false },
                colors: ['#556ee6', '#34c38f', '#f1b44c', '#f46a6a', '#50a5f1'],
            };
        },
    },
}
</script>
